import { RecordIsDirty } from '@records/state/current-record/record-is-dirty.action';
import { DataObject } from '@shared/models/data-object.model';
import { map } from 'rxjs/operators';
import { ExecutableAction, ExecutableActionParam } from '../utils/executable-action';
import { CurrentDataModel } from './current-data.model';
export class UpdateData implements ExecutableAction<CurrentDataModel> {
  static readonly type = '[Current Data] Update Record Data';
  constructor(
    private updateObject: DataObject,
    private markAsDirty: boolean = true
  ) {}
  execute(params: ExecutableActionParam<CurrentDataModel>) {
    const state: CurrentDataModel = params.ctx.getState();
    // create new current-data state
    const partialDataState: Partial<CurrentDataModel> = {
      record: { ...state.record, ...this.updateObject },
    };
    return this.markAsDirty
      ? this.patchRecordAndMarkAsDirty(partialDataState, params)
      : this.updateRecordOnly(partialDataState, params);
  }
  private patchRecordAndMarkAsDirty(partialDataState: DataObject, params: ExecutableActionParam<CurrentDataModel>) {
    return params.store.dispatch(new RecordIsDirty()).pipe(
      map(() => {
        // update record state
        return params.ctx.patchState(partialDataState);
      })
    );
  }
  private updateRecordOnly(partialDataState: DataObject, params: ExecutableActionParam<CurrentDataModel>) {
    return params.ctx.patchState(partialDataState);
  }
}
